export const TABS = {
  sources: 'sources',
  activity: 'activity'
};